export * from './notification-contact-dealer-skeleton';
